import RecentlyViewed from '../components/RecentlyViewed'

class Product {
    constructor (theme) {
        this._theme = theme
    }

    onInit () {
        let productComp = this._theme.getComponentsById('mainProduct')
        if (productComp) {
            let productObj = productComp.product
            RecentlyViewed.viewItem(productObj.handle)
        }
    }
}
export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js